/** @format */
import React from 'react'
import moment from 'moment'

import FileListTable from './FileListTable'

export default function BatchList({
    batchId,
    date,
    processedFiles,
    unprocessedFiles,
    supplierName,
}) {
    return (
        <div className="panel panel-default" key={batchId}>
            <div className="panel-heading">
                <h3 className="panel-title">
                    {moment(date).format('D MMM YYYY, h:mm A')}
                </h3>
            </div>
            <div className="panel-body">
                <div>Supplier: {supplierName}</div>
                <div>Processed: {processedFiles.length}</div>
                <div>Unrocessed: {unprocessedFiles.length}</div>
            </div>
            <FileListTable
                processedFiles={processedFiles}
                unprocessedFiles={unprocessedFiles}
            />
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/pages/FergusLogs/SupplierDocuments/BatchList.js